import classNames from 'classnames'

type PropTypes = {
  selected: boolean
  onOptionSelected: () => void
  children: React.ReactNode
}

const ViewPickerItem = ({ selected, onOptionSelected, children }: PropTypes) => {
  return (
    <button
      onClick={onOptionSelected}
      className={classNames(
        'transition-all rounded-lg border font-medium text-sm text-gray-900 flex items-center justify-center h-10 w-10',
        'hover:bg-gray-300 hover:border-gray-500',
        {
          'border-primary-900': selected,
          'border-transparent': !selected,
        },
      )}
    >
      <span className={selected ? 'text-primary-900' : ''}>
        {children}
      </span>
    </button>
  )
}

export default ViewPickerItem
